import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import "./Information.css";
import SplitPanel from "../../../Helpers/SplitPanel";
import InfoPanel from "../../../Helpers/InfoPanel";
import InfoHeader from "./InfoHeader";
import InfoSubheader from "./InfoSubheader";
import { prettyDates, capitalize } from "../../../../actions/utils";
import { RESIDENCE_TYPES } from "../../../../constants";

const empty = "-";
const maxRoomCount = 6;

export default class PropertyInformation extends Component {

    static propTypes = {
        properties: PropTypes.object.isRequired,
        compare: PropTypes.object,
        landlord: PropTypes.bool,
        title: PropTypes.node
    }

    constructor(props) {
        super(props);
        this.compared = this.compared.bind(this);
    }

    translateResidenceType(residenceType) {
        if (!residenceType)
            return empty;
        let result = ""
        if (typeof residenceType === "string")
            result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
        // let result = "";
        if (result === "")
            result = residenceType
                .map(type => RESIDENCE_TYPES.find(item => item.value === type))
        result = result.map(type => type ? type.displayName : undefined)
            .filter(Boolean)
            .join(", ")
        // let resTypes = Array.isArray( residenceType ) ? residenceType[0] : residenceType;
        // if ( resTypes.office )
        //     result = `${result}${result ? ", " : ""}Office`;
        // if ( resTypes.storage )
        //     result = `${result}${result ? ", " : ""}Storage`;
        // if ( resTypes.retail )
        //     result = `${result}${result ? ", " : ""}Retail`;
        return result;
    }


    translateRange(min, max) {
        if ((!min && min !== 0) && (!max && max !== 0))
            return empty;
        if (min === max) {
            return String(min);
        }
        let usedMin = min;
        let usedMax = max;
        if ((!min && min !== 0))
            usedMin = 0;
        if ((!max && max !== 0))
            return `${this.translateBigNumber(Math.round(usedMin))}+`
        return `${this.translateBigNumber(Math.round(usedMin))} - ${this.translateBigNumber(Math.round(usedMax))}`
    }

    translateDateRange(from, to) {
        return to
            ? (from
                ? `${prettyDates.day(from)} - ${prettyDates.day(to)}`
                : `Until ${prettyDates.day(to)}`)
            : (from
                ? `${prettyDates.day(from)} -`
                : empty)
    }

    translateBool(value) {
        return value
            ? <span className="Information-yes">Yes</span>
            : <span className="Information-no">No</span>
    }


    translateBigNumber(number) {
        try {
            return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
        } catch (e) {
            return number
        }
    }

    compared(key, title, value) {
        if (!this.props.compare) {
            return [title, value];
        }
        const match = key === null ? null : (this.props.compare || {})[key];
        return [
            (<div>
                <span className={match !== false ? match !== null ? "Information-match-positive" : "Information-match-unresolved" : "Information-match-negative"}>
                    <div className="Information-match" />
                </span>
                <span>
                    {title}
                </span>
            </div>),
            (<div className="Information-value">{value}</div>)
        ];
    }

    render() {
        const { properties, listing, title } = this.props;
        console.log('properties', properties)
        return (
            <div className="Information-section">
                <InfoHeader>
                    {title || ""}
                </InfoHeader>
                <SplitPanel
                    left={
                        <Fragment>
                            <InfoSubheader>
                                {listing ? "Basic information" : "Basic requirements"}
                            </InfoSubheader>
                            <InfoPanel
                                rows={[
                                    this.compared(null, listing ? "Address:" : "Area:", capitalize(properties.address) || empty),
                                    this.compared(null, "Type:", this.translateResidenceType(properties.residenceType)), //TODO: add residenceType to matchmaking consideration and match results
                                    this.compared("size", "Size:", `${listing ? properties.size : this.translateRange(properties.size, properties.sizeMax)} m²`),
                                    this.compared("rent", "Rent per Month:", `${listing ? this.translateBigNumber(properties.rent) : this.translateRange(properties.rentMin, properties.rent)} €`),
                                    this.compared("rent", "Rent per Year:", `${listing ? this.translateBigNumber(12 * properties.rent) : this.translateRange(12 * properties.rentMin, 12 * properties.rent)} €`),
                                    this.compared("rentPeriod", "Rent Period:", this.translateDateRange(properties.whenAvailable, properties.moveOutDate)), //TODO: add move dates to matchmaking consideration and match results
                                    listing ? this.compared(null, "Description:", capitalize(properties.description) || empty) : undefined,
                                ]}
                            />
                        </Fragment>
                    }
                    right={
                        <Fragment>
                            <InfoSubheader>
                                {listing ? "Additional information" : "Additional wishes"}
                            </InfoSubheader>
                            <InfoPanel
                                rows={[
                                    this.compared("kitchen", "Kitchen:", this.translateBool(properties.kitchen)),
                                    this.compared("wc", "Wc:", this.translateBool(properties.wc)),
                                    this.compared("shower", "Shower:", this.translateBool(properties.shower)),
                                    this.compared("breakRoom", "Break Room:", this.translateBool(properties.breakRoom)),
                                    this.compared("parking", "Parking:", this.translateBool(properties.parking)),
                                ]}
                            />
                        </Fragment>
                    }
                />
            </div>
        );
    }

}